module.exports = __webpack_public_path__ + "2d2de0c270a314dc3ec563f226549b18.png";